import { jsx as _jsx } from "react/jsx-runtime";
import { StreetViewIcon } from "@gemini/icons";
import { Button } from "@gemini/ui";
import { useI18n } from "@/shared/hooks";
import { useBrandUrl, useTrackingLinkClick } from "@/hooks";
import { useLocation } from "@/location/hooks/useLocation";
import { useClassified } from "@/contexts/classified";
import { CellContentCustom } from "@/components/CellContentCustom/CellContentCustom";
import { useBrowserAPI } from "@/hooks/useBrowserAPI";
export const MapStreetView = ({ variant }) => {
    var _a, _b;
    const { t } = useI18n();
    const { av_distribution_type_global } = (_b = (_a = useClassified()) === null || _a === void 0 ? void 0 : _a.tracking) !== null && _b !== void 0 ? _b : {};
    const { geometry, isAddressPublished } = useLocation() || {};
    const { bWindow } = useBrowserAPI();
    const placeholderUrl = useBrandUrl({
        endpoint: "/shared/images/map/street-view.png",
    });
    const latitude = geometry === null || geometry === void 0 ? void 0 : geometry.coordinates[1];
    const longitude = geometry === null || geometry === void 0 ? void 0 : geometry.coordinates[0];
    /**
     * q= Query - anything passed in this parameter is treated as if it had been typed into the query box on the maps.google.com page
     * layer= Activates overlays. Current option is `c` street view
     * cbll= Latitude,longitude for street view
     * @example https://stackoverflow.com/questions/387942/google-street-view-url
     */
    const streetViewUrl = `http://maps.google.com/maps?q=&layer=c&cbll=${latitude},${longitude}`;
    const trackingData = {
        link_url: streetViewUrl,
        outbound: true,
        av_zone: variant === "preview" ? "middle" : "map",
        av_distribution_type_global,
        av_pagetitle: variant === "preview" ? "classified_detail" : "classified_detail_map",
    };
    const handleTrackingLinkClick = useTrackingLinkClick({
        event: "outlink",
        data: trackingData,
    });
    const handleButtonPress = () => {
        bWindow.open(streetViewUrl, "_blank");
        handleTrackingLinkClick();
    };
    if (!isAddressPublished)
        return null;
    if (variant === "fullscreen") {
        return (_jsx(Button, { icon: StreetViewIcon, onPress: handleButtonPress, variant: "secondary-floating", iconOnly: true, children: t("location.map.street_view.description") }));
    }
    return (_jsx(CellContentCustom, { title: t("location.map.street_view.title"), description: t("location.map.street_view.description"), placeholderStart: {
            alt: "Street view image",
            url: placeholderUrl,
        }, onPress: handleButtonPress, isExternal: true }));
};
